import React, { useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { useNavigate } from "react-router-dom";

export default function CreateRoom() {
  const [roomId, setRoomId] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const createRoom = async () => {
    if (!roomId || !password) return;

    await setDoc(doc(db, "rooms", roomId), {
      password: password,
      createdAt: new Date(),
    });

    navigate(`/room/${roomId}`);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Create Room</h2>

      <input
        placeholder="Room Name"
        value={roomId}
        onChange={(e) => setRoomId(e.target.value)}
      />

      <input
        placeholder="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button onClick={createRoom}>Create</button>
    </div>
  );
}
